import React, { useState } from "react";
import PropTypes from "prop-types";

import { Row, Col, Collapse, Well } from "react-bootstrap";

import CustomerSelect from "../common/CustomerSelect";
import UserSelect from "../common/UserSelect";

import SupportResourcesPageHeader from "./SupportResourcesPageHeader";

export default function SupportResourcesFilters({
  filters,
  onChange,
  loading,
  onReset,
  onFilter,
  isNightMode
}) {
  const [openFilters, setOpenFilters] = useState(true);
  return (
    <React.Fragment>
      <SupportResourcesPageHeader
        isNightMode={isNightMode}
        onClick={() => {
          setOpenFilters(!openFilters);
        }}
      />
      <Collapse
        in={openFilters}
        className="filter-container"
        style={{ paddingLeft: 0 }}
      >
        <div>
          <Well>
            <Row style={{ marginBottom: 15 }}>
              <Col md={4}>
                <CustomerSelect
                  isMulti
                  label=""
                  placeholder="Customer"
                  value={filters.customer || []}
                  onChange={(e) => onChange("customer", e || [])}
                />
              </Col>
              <Col md={4}>
                <UserSelect
                  isMulti
                  label=""
                  placeholder="Employee"
                  value={filters.employee || []}
                  onChange={(e) => onChange("employee", e || [])}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <button
                  className="btn btn-warning"
                  type="button"
                  onClick={onReset}
                  disabled={loading}
                >
                  Reset
                </button>
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={onFilter}
                  disabled={loading}
                >
                  Fetch Data
                </button>
              </Col>
            </Row>
          </Well>
        </div>
      </Collapse>
    </React.Fragment>
  );
}

SupportResourcesFilters.propTypes = {
  filters: PropTypes.object,
  onChange: PropTypes.func,
  loading: PropTypes.bool,
  onReset: PropTypes.func,
  onFilter: PropTypes.func,
  isNightMode: PropTypes.bool
};

SupportResourcesFilters.defaultProps = {
  filters: {}
};
